import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Category } from './category';
import { FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { CategoryService } from './category.service';

@Component({
  selector: 'wsg-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  @Input() label = 'Category';
  processing = false;
  categories: Category[];
  @Input() parent: FormGroup;
  @Input() value = '';
  @Input() model: any;
  @Input() location = '';
  @Input() allLocations = false;
  @Output() modelChange: EventEmitter<Category> = new EventEmitter<Category>();
  @Input() setDefaultOption = true;
  @Input() includeAll = false;
  @Input() formPropertyName = 'category';
  @Input() floatLabel = 'always';
  @Input() showNone = false;
  @Input() showAllCategories = false;
  @Input() showAllRevenue = false;
  getAllUsers = false;

  constructor(private categoryService: CategoryService, 
              private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {

    const that = this;

    this.processing = true;
    this.categoryService.get()
                        .subscribe(categories => {
                          if (this.includeAll) {
                            const allCategory = new Category();
                            allCategory.id = 'ALL';
                            allCategory.description = 'All';

                            categories.splice(0, 0, allCategory);
                          }

                          this.categories = categories;

                          if (!this.isReactive() && categories.length > 0 && this.setDefaultOption) {
                            if (this.value !== '') {
                              this.modelChange.emit(this.categories.find(c => c.id.toString() === this.value));
                            } else {
                              this.modelChange.emit(this.categories[0]);
                            }
                          } else if (this.isReactive() && this.value) {
                            this.parent.controls[this.formPropertyName].patchValue(this.value);
                            this.changeDetectorRef.detectChanges();
                          } else if (this.isReactive() && this.setDefaultOption) {
                            this.parent.controls[this.formPropertyName].patchValue(this.categories[0].id);
                            this.changeDetectorRef.detectChanges();
                          } else if (this.isReactive() && this.showNone) {
                            this.parent.controls[this.formPropertyName].setValue('');
                          }

                          this.processing = false;
                        }, error => {
                          this.processing = false;
                        });
  }

  isReactive(): boolean {
    return typeof this.parent !== 'undefined';
  }

  updateModel() {
    const client = this.categories.filter(u => u.id === this.model);
    this.modelChange.emit(client[0]);
  }
}
